module.exports = __webpack_public_path__ + "static/media/Complete truck 1.99b3165e.svg";